module.exports = __webpack_public_path__ + "static/media/logo_navbar.66cc4d38.png";